import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { PlanAccountTypes } from "@/types";

export interface GetPlanAccountState {
  planAccount: PlanAccountTypes.PlanAccountInfo;
}

const DEFAULT_GET_PLAN_ACCOUNT_STATE: GetPlanAccountState = {
  planAccount: {
    created_at: "",
    end_date: "",
    external_account_id: "",
    id: null,
    name: "",
    plan_account_id: null,
    plan_id: null,
    start_date: "",
  },
};

export default (state: GetPlanAccountState = DEFAULT_GET_PLAN_ACCOUNT_STATE, action: Action): {} => {
  if (action.type === ActionTypes.GET_PLAN_ACCOUNT_RESULTS) {
    return {
      ...state,
      planAccount: action.payload,
    };
  } else {
    return state;
  }
};
